import { getApps,initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';

// Firebase configuration for admin portal
// Uses Firebase's default app pattern
const getFirebaseApp = () => {
	// Check if any Firebase apps already exist
	const existingApps = getApps();

	if (existingApps.length > 0) {
		// Return the first (default) app if it exists
		return existingApps[0];
	} else {
		// Parse the VITE_FIREBASE_CONFIG environment variable and create default app
		const appConfig = JSON.parse(import.meta.env.VITE_FIREBASE_CONFIG);
		return initializeApp(appConfig); // No name parameter = default app
	}
};

// Initialize Firebase app
const app = getFirebaseApp();

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);

// Initialize Firebase Storage
export const storage = getStorage(app);

export default app;
